module.exports = __webpack_public_path__ + "mo/img/process_2.c8cd6b7a.png";